/**
 * Deterministic color palette for vertex group surface tinting.
 *
 * Hue rotates by the golden-ratio conjugate (≈ 0.61803) so successive groups
 * land on visually distinct hues — well over a dozen before perceptual repeat.
 * Saturation and lightness are fixed at mid values to keep the tints readable
 * over both light and dark mesh materials.
 */

import * as THREE from "three/webgpu";

const HUE_OFFSET = 0.55;
const HUE_STEP = 0.6180339887498949;
const SATURATION = 0.75;
const LIGHTNESS = 0.6;

export function groupColorAt(index: number): THREE.Color {
  const hue = (HUE_OFFSET + index * HUE_STEP) % 1;
  return new THREE.Color().setHSL(hue, SATURATION, LIGHTNESS);
}
